











import {Component, Prop, Vue} from "vue-property-decorator";
import Editor from '@tinymce/tinymce-vue';

@Component({
  components: {
    Editor
  }
})
export default class RichTextEditor extends Vue {
  @Prop({default:true}) required!:boolean;
  @Prop({}) value!:string;
  @Prop({default:"12"}) md!:string;
  apiKey = "6lgo1smnjmht75ek0dgdkav5sty0fcm2uyj0agqxz8v7fad2";
  updateValue (value:string) {
    this.$emit('input', value)
  }
}
